export const search = {
  noResultsFound: "No results found",
  suggestions: "Suggestions",
  creators: "Creators",
  series: "Series",
  releases: "Releases",
  viewAllSeriesResults: "View all series results",
  viewAllReleaseResults: "View all release results",
  safeModeIsOn: "Safe Mode is active",
  updatePreferences: "Update preferences",
};
